(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image_text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      const videoWrapper = document.querySelector('.t4s-video-wrapper');
      const video = videoWrapper.querySelector('.custom-video');
      const playBtn = videoWrapper.querySelector('.custom-play-btn');

      // Clicking anywhere on video wrapper toggles play/pause
      videoWrapper.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      // Keep button visibility synced with video state
      video.addEventListener('pause', function () {
        playBtn.classList.remove('video-play-hide');
      });

      video.addEventListener('play', function () {
        playBtn.classList.add('video-play-hide');
      });
    });

  } catch(e) { console.error(e); }
})();
})();
